<template>
    <div>
        <router-view />
    </div>
</template>
<script>

export default({
  name: "auth-layout",
  mounted() {
  },
  methods: {
    
  },
});
</script>